document.addEventListener("turbo:load", () => {
  let menu = document.querySelector('#menu-icon');
  let drawer = document.querySelector('.menu-nav-block');
  let closeMenu = document.querySelector('#close-menu-icon');
  let closeElements = document.querySelectorAll('.close-element');

  // Turbo now fires this on every website navigation, including pages without the
  // drawer menu, where these lookups return null.
  if (!menu || !drawer || !closeMenu) return;

  menu.addEventListener('click', function(e) {
    drawer.classList.add('open');
    menu.classList.remove('open');
    closeMenu.classList.add('open');
    e.stopPropagation();
  });
  closeMenu.addEventListener('click', function(e) {
    drawer.classList.remove('open');
    menu.classList.add('open');
    closeMenu.classList.remove('open');
    e.stopPropagation();
  });
  closeElements.forEach( function(e) {
    e.addEventListener('click', function(e) {
      drawer.classList.remove('open');
      menu.classList.add('open');
      closeMenu.classList.remove('open');
      e.stopPropagation();
    });
  });
});
